import { BaseEventsService } from './base-event-service';
import { dataTableEvents } from '../constants/data-table-events';

function getActionTarget(event: any, attributeName: string): HTMLElement | null {
  const target = event.target as Node | null;
  const targetElement = target instanceof Element ? target : target?.parentElement;

  return (targetElement?.closest(`[${attributeName}]`) as HTMLElement | null) || null;
}

function processCommonMenuItems(eventsService: BaseEventsService, event: any): boolean {
  const reviewLinkTarget = getActionTarget(event, dataTableEvents.common.reviewLink);

  // common
  if (reviewLinkTarget) {
    eventsService.onReviewLink(reviewLinkTarget.getAttribute(dataTableEvents.common.reviewLink));
    return true;
  }

  const reviewDocumentTarget = getActionTarget(event, dataTableEvents.common.reviewDocument);

  if (reviewDocumentTarget) {
    eventsService.onReviewDocument(
      reviewDocumentTarget.getAttribute(dataTableEvents.common.reviewDocument),
    );
    return true;
  }

  const viewTarget = getActionTarget(event, dataTableEvents.common.view);

  if (viewTarget) {
    eventsService.onView(viewTarget.getAttribute(dataTableEvents.common.view));
    return true;
  }

  const queryLinkTarget = getActionTarget(event, dataTableEvents.common.queryLink);

  if (queryLinkTarget) {
    eventsService.onQueryLink(queryLinkTarget.getAttribute(dataTableEvents.common.queryLink));
    return true;
  }

  const addClausesTarget = getActionTarget(event, dataTableEvents.common.addClausesLink);

  if (addClausesTarget) {
    eventsService.onAddClausesLink(
      addClausesTarget.getAttribute(dataTableEvents.common.addClausesLink),
    );
    return true;
  }

  const editPropertiesTarget = getActionTarget(event, dataTableEvents.common.editProperties);

  if (editPropertiesTarget) {
    eventsService.onEditProperties(
      editPropertiesTarget.getAttribute(dataTableEvents.common.editProperties),
    );
    return true;
  }

  const unlinkTarget = getActionTarget(event, dataTableEvents.common.unlink);

  if (unlinkTarget) {
    eventsService.onUnlink(unlinkTarget.getAttribute(dataTableEvents.common.unlink));
    return true;
  }

  const cancelTarget = getActionTarget(event, dataTableEvents.common.cancel);

  if (cancelTarget) {
    eventsService.onCancel(cancelTarget.getAttribute(dataTableEvents.common.cancel));
    return true;
  }

  const editTarget = getActionTarget(event, dataTableEvents.common.edit);

  if (editTarget) {
    eventsService.onEdit(editTarget.getAttribute(dataTableEvents.common.edit));
    return true;
  }

  const editInDesktopTarget = getActionTarget(event, dataTableEvents.common.editInDesktop);

  if (editInDesktopTarget) {
    eventsService.onEditInDesktop(
      editInDesktopTarget.getAttribute(dataTableEvents.common.editInDesktop),
    );
    return true;
  }

  const relaunchReviewTarget = getActionTarget(event, dataTableEvents.common.relaunchReview);

  if (relaunchReviewTarget) {
    eventsService.onRelaunchReview(
      relaunchReviewTarget.getAttribute(dataTableEvents.common.relaunchReview),
    );
    return true;
  }

  const sendReportTarget = getActionTarget(event, dataTableEvents.common.sendReport);

  if (sendReportTarget) {
    eventsService.onSendReport(sendReportTarget.getAttribute(dataTableEvents.common.sendReport));
    return true;
  }

  const requestSignaturesTarget = getActionTarget(event, dataTableEvents.common.requestSignatures);

  if (requestSignaturesTarget) {
    eventsService.onRequestSignatures(
      requestSignaturesTarget.getAttribute(dataTableEvents.common.requestSignatures),
    );
    return true;
  }

  const deleteTarget = getActionTarget(event, dataTableEvents.common.delete);

  if (deleteTarget) {
    eventsService.onDelete(deleteTarget.getAttribute(dataTableEvents.common.delete));
    return true;
  }

  const deactivateTarget = getActionTarget(event, dataTableEvents.common.deactivate);

  if (deactivateTarget) {
    eventsService.onDeactivate(deactivateTarget.getAttribute(dataTableEvents.common.deactivate));
    return true;
  }

  const searchTarget = getActionTarget(event, dataTableEvents.common.search);

  if (searchTarget) {
    eventsService.onSearch(searchTarget.getAttribute(dataTableEvents.common.search));
    return true;
  }

  const applyTarget = getActionTarget(event, dataTableEvents.common.apply);

  if (applyTarget) {
    eventsService.onApply(applyTarget.getAttribute(dataTableEvents.common.apply));
    return true;
  }

  const caseTarget = getActionTarget(event, dataTableEvents.common.case);

  if (caseTarget) {
    eventsService.onCase(caseTarget.getAttribute(dataTableEvents.common.case));
    return true;
  }

  const nameClickTarget = getActionTarget(event, dataTableEvents.common.nameClick);

  if (nameClickTarget) {
    eventsService.onNameClick(nameClickTarget.getAttribute(dataTableEvents.common.nameClick));
    return true;
  }

  const detailsTarget = getActionTarget(event, dataTableEvents.common.details);

  if (detailsTarget) {
    eventsService.onDetails({
      uniqueId: detailsTarget.getAttribute(dataTableEvents.common.details),
      focusField:
        detailsTarget.getAttribute(dataTableEvents.common.detailsField) || undefined,
    });
    return true;
  }

  const downloadTarget = getActionTarget(event, dataTableEvents.common.download);

  if (downloadTarget) {
    eventsService.onDownload(downloadTarget.getAttribute(dataTableEvents.common.download));
    return true;
  }

  const previewTarget = getActionTarget(event, dataTableEvents.common.previw);

  if (previewTarget) {
    eventsService.onPreview(previewTarget.getAttribute(dataTableEvents.common.previw));
    return true;
  }

  return false;
}

export { processCommonMenuItems };
